import { gql } from '@apollo/client';

export const SHOOTER_AVAILABILITY_QUERY = gql`
	query ShooterAvailability($startDate: Int!, $endDate: Int!, $eventId: ID, $tenantIds: [ID], $cities: [String], $roles: [String], $vendorId: String!) {
		shooterAvailability(startDate: $startDate, endDate: $endDate, eventId: $eventId, tenantIds: $tenantIds, cities: $cities, roles: $roles) {
			demand {
				date
				totalEvents
				needCrew
				events {
					eventId
					projectId
					projectTitle
					eventName
					city
					workspaceId
					needsCrew
					assignedCount
					requiredCount
				}
			}
			shooters {
				userId
				name
				displayPicture
				isFreelancer
				skillLevel {
					candidPhotography
					candidCinematography
					traditionalPhotography
					traditionalVideography
					leadership
				}
				dates {
					date
					status
					events {
						eventId
						projectId
						projectTitle
						eventName
						city
						venue
						workspaceId
						eventTime
						reportingTime
						durationInHrs
						isFullDay
						roles {
							role
							subRole
						}
					}
					eventCount
					previousDayEventCount
					nextDayEventCount
				}
				fitScore
				fitReasons
			}
		}
		vendorInfo(vendorId: $vendorId) {
			id
			businessName
			associatedTenants {
				_id
				workspaceId
				workspaceKey
			}
		}
	}
`;

export const SUGGESTED_CREW_QUERY = gql`
	query SuggestedCrew($eventId: ID!, $roles: [CrewRoleInput!]!) {
		suggestedCrew(eventId: $eventId, roles: $roles) {
			role
			subRole
			suggestions {
				userId
				name
				displayPicture
				fitScore
				fitReasons
				status
				skillScore
				events {
					eventName
					eventTime
					isFullDay
				}
			}
		}
	}
`;

export const SHOOTER_TIMELINE_QUERY = gql`
	query ShooterTimeline($startDate: Int!, $endDate: Int!) {
		shooterAvailability(startDate: $startDate, endDate: $endDate) {
			shooters {
				userId
				name
				dates {
					date
					status
					events {
						eventId
						projectId
						projectTitle
						eventName
						city
						venue
						workspaceId
						eventTime
						reportingTime
						durationInHrs
						isFullDay
						roles {
							role
							subRole
						}
					}
					eventCount
				}
			}
		}
	}
`;
